/**
 * 禁止 Ctrl/Meta + 滚轮整页缩放（不记录、不弹窗，仅 preventDefault）。
 */
/**
 * @param {{ getActive: () => boolean }} ctx
 * @returns {{ attach: () => void; detach: () => void }}
 */
export function createWheelZoomGuard(ctx) {
  const handleWheel = (e) => {
    if (!ctx.getActive()) return;

    if (e.ctrlKey || e.metaKey) {
      e.preventDefault();
    }
  };

  return {
    attach() {
      window.addEventListener("wheel", handleWheel, { passive: false });
    },
    detach() {
      window.removeEventListener("wheel", handleWheel);
    },
  };
}
